import * as React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Settings,
} from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ApprovalIcon from "@mui/icons-material/Approval";
import PersonIcon from "@mui/icons-material/Person";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GroupIcon from "@mui/icons-material/Group";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "src/slices/auth/selectors";
import { AppUser } from "src/types/auth/auth";
import { RoutePaths } from "src/constants";

export const DrawerNavigationList = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const user: AppUser = useSelector(selectUser);
  const role = user?.employeeInfo?.employeeRole;
  console.log("user here..", user);

  const [openDropdown, setOpenDropdown] = React.useState<string | null>(null);

  const handleToggle = (label: string) => {
    setOpenDropdown((prev) => (prev === label ? null : label));
  };


  // !commented code will used in future!

  const commonItems = [
    {
      label: "Timesheet",
      link: RoutePaths.TIMESHEET_LISTING,
      icon: <CalendarMonthIcon />,
    },
    // {
    //   label: "Leave Request",
    //   // link: RoutePaths.LEAVE_REQUEST,
    //   icon: <ApprovalIcon />,
    // },
  ];

  const hrItems = [
    // {
    //   label: "Approvals",
    //   icon: <ApprovalIcon />,
    //   children: [
    //     {
    //       label: "Leave",
    //       // link: RoutePaths.LEAVE_APPROVAL,
    //       icon: <ApprovalIcon />,
    //     },
    //   ],
    // },
    {
      label: "Setup",
      icon: <Settings />,
      children: [
        {
          label: "Leave/Holiday",
          link: RoutePaths.LEAVE_HOLIDAY,
          icon: <HolidayVillageIcon />,
        },
        {
          label: "Employee",
          link: RoutePaths.EMPLOYEE_LISTING,
          icon: <PersonIcon />,
        },
      ],
    },
    // {
    //   label: "Reports",
    //   icon: <AssessmentIcon />,
    //   children: [
    //     {
    //       label: "Leaves",
    //       link: RoutePaths.REPORTS,
    //       icon: <AssessmentIcon />,
    //     },
    //   ],
    // },
  ];

  const financeItems = [
    {
      label: "Reports",
      icon: <AssessmentIcon />,
      children: [
        {
          label: "Timesheet",
          link: RoutePaths.REPORTS,
          icon: <AssessmentIcon />,
        },
      ],
    },
  ];

  const managerItems = [
    {
      label: "Approvals",
      icon: <ApprovalIcon />,
      children: [
        // {
        //   label: "Leave",
        //   // link: RoutePaths.LEAVE_APPROVAL,
        //   icon: <ApprovalIcon />,
        // },
        {
          label: "Timesheet",
          link: RoutePaths.APPROVAL_TIMESHEET,
          icon: <CalendarMonthIcon />,
        },
      ],
    },
    {
      label: "Setup",
      icon: <LocalAtmIcon />,
      children: [
        {
          label: "Customers",
          link: RoutePaths.CUSTOMER_LISTING,
          icon: <GroupIcon />,
        },
        {
          label: "Projects",
          link: RoutePaths.PROJECTS,
          icon: <AssignmentIcon />,
        },
        {
          label: "Employee Assignment",
          link: RoutePaths.EMP_PROJECT_LISTING,
          icon: <GroupIcon />,
        },
      ],
    },
    {
      label: "Reports",
      icon: <AssessmentIcon />,
      children: [
        {
          label: "Timesheet",
          link: RoutePaths.REPORTS,
          icon: <AssessmentIcon />,
        },
        // {
        //   label: "Leaves",
        //   // link: RoutePaths.REPORTS_LEAVES,
        //   icon: <ApprovalIcon />,
        // },
      ],
    },
  ];

  const employeeItems: any[] = [];

  const roleItemsMap: Record<string, any[]> = {
    HR: hrItems,
    Finance: financeItems,
    "Project Manager": managerItems,
    Employee: employeeItems,
  };

  const roleSpecificItems = roleItemsMap[role] || [];

  const renderNavItem = (item: any, level = 0) => (
    <ListItemButton
      key={item.label}
      onClick={() => item.link && navigate(item.link)}
      selected={pathname === item.link}
      sx={{
        pl: 2 + level * 3,
        display: "flex",
        alignItems: "center",
        gap: 1,
        "&.Mui-selected": {
          color: "white",
          backgroundColor: "#F15C3B",
          ":hover": { backgroundColor: "#f28269" },
        },
      }}
    >
      {item.icon && (
        <ListItemIcon
          sx={{
            minWidth: 32,
            color: pathname === item.link ? "white" : "inherit",
            // ml: level > 0 ? 2 : 0,
          }}
        >
          {item.icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={item.label}
        // sx={{ "& .MuiListItemText-primary": { fontSize: 14 } }}
      />
    </ListItemButton>
  );

  const renderDropdown = (group: any) => (
    <React.Fragment key={group.label}>
      <ListItemButton onClick={() => handleToggle(group.label)}>
        <ListItemIcon>{group.icon}</ListItemIcon>
        <ListItemText primary={group.label} />
        {openDropdown === group.label ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openDropdown === group.label} timeout="auto" unmountOnExit>
        {group.children.map((child) => renderNavItem(child, 2))}
      </Collapse>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {commonItems.map((item) => renderNavItem(item))}

      {roleSpecificItems.map((item) =>
        item.children ? renderDropdown(item) : renderNavItem(item)
      )}
    </React.Fragment>
  );
};
